import { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import {
  getOptionsForModalWindowTrainedUser,
  setOptionsForModalWindowTrainedUser,
  setOptionsModalWindowDisabledInputs,
} from "../../../../containers/KnowledgeTest/recordTrainedUsers/cardRecordTrainedUsers/optionsForModalWindowTrainedUser";

import SelectForForm from "../../../GeneralComponents/componentsForForm/selectForForm/SelectForForm";
import SelectWithSearch from "../../../GeneralComponents/componentsForForm/selectWithSearch/SelectWithSearch";
import InputForForm from "../../../GeneralComponents/componentsForForm/inputForForm/InputForForm";

import styles from "./modalWindowAddUser.module.css";

function ModalWindowAddUser({ show, setShowWindow, modalTitle, mode, handleSave, dataModal, setDataModal }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm({ mode: "onChange" });

  const trainingDocTypes = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allTrainingDocTypes.map((el) => {
      return { ...el, key: "trainingDocumentsDocTypeId" };
    });
  });

  const allCountries = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allCountries.map((el) => {
      return { ...el, key: "birthPlace", label: el.countryFullname };
    });
  });
  const [inputOptions, setInputOptions] = useState({});
  async function setInitParamsForOptions() {
    await setOptionsForModalWindowTrainedUser("firstInit", {
      trainingDocTypes: trainingDocTypes,
      countries: allCountries,
    });
    if (mode === "edit") {
      setOptionsModalWindowDisabledInputs();
    }
    setInputOptions(getOptionsForModalWindowTrainedUser());
  }

  useEffect(() => {
    setInitParamsForOptions().then();
  }, []);

  console.log(dataModal);
  const resolveSubmit = (data) => {
    if (mode === "add") {
      data.id = dataModal?.id;
      if (data.trainingDocumentsDocTypeId && typeof data.trainingDocumentsDocTypeId === "object") {
        data.trainingDocumentsDocTypeIdName = dataModal.trainingDocumentsDocTypeId.label;
        data.trainingDocumentsDocTypeId = dataModal.trainingDocumentsDocTypeId.value;
      }
      if (data.birthPlace && typeof data.birthPlace === "object") {
        data.birthPlace = dataModal.birthPlace.value;
        data.birthPlaceName = dataModal.birthPlace.label;
      }
      handleSave(data);
    }
    if (mode === "edit") {
      data.id = dataModal.id;
      if (typeof data.trainingDocumentsDocTypeId === "object") {
        data.trainingDocumentsDocTypeIdName = data.trainingDocumentsDocTypeId.label;
        data.trainingDocumentsDocTypeId = data.trainingDocumentsDocTypeId.value;
      }
      if (typeof data.birthPlace === "object") {
        data.birthPlace = dataModal.birthPlace.value;
        data.birthPlaceName = dataModal.birthPlace.label;
      }
      handleSave(data);
    }
  };
  const handleClose = (e) => {
    if (e) e.preventDefault();
    setDataModal(null);
    setShowWindow(!show);
  };
  // useEffect(() => {
  //   if (mode === "add") {
  //     dataModal.dataForTable = [];
  //   }
  // }, []);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      className={styles["modal-container"]}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{modalTitle}</Modal.Title>
      </Modal.Header>
      <ModalBody className={styles["form-body"]}>
        <form
          className={styles.container}
          onSubmit={handleSubmit(resolveSubmit)}>
          {Object.values(inputOptions).map((option) => {
            switch (true) {
              case option.type === "select": {
                return (
                  <div
                    id={option.id}
                    className={styles[`box-${option.key}`]}>
                    <SelectForForm
                      mode={mode}
                      register={register}
                      inputProps={option}
                      errors={errors}
                      setValue={setValue}
                      dataForm={dataModal}
                    />
                  </div>
                );
              }
              case option.type === "selectWithSearch": {
                return (
                  <div
                    id={option.id}
                    className={styles[`box-${option.key}`]}>
                    <SelectWithSearch
                      mode={mode}
                      inputProps={option}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      dataForm={dataModal}
                    />
                  </div>
                );
              }
              default:
                return (
                  <div
                    id={option.id}
                    className={styles[`box-${option.key}`]}>
                    <InputForForm
                      mode={mode}
                      register={register}
                      inputProps={option}
                      errors={errors}
                      setValue={setValue}
                      dataForm={dataModal}
                      getValues={getValues}
                      setError={setError}
                      clearErrors={clearErrors}
                    />
                  </div>
                );
            }
          })}
          <div className={styles["box-buttons"]}>
            <button className={styles["save-btn"]}>Сохранить</button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}

export default ModalWindowAddUser;
